module.exports = __webpack_public_path__ + "img/maps-dashboard.c945390f.png";